import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Image from 'react-bootstrap/Image';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import certBaumit from './assets/images/certifikaty/baumit.png';
//import certCenik from './assets/images/certifikaty/cenik.png';
import certKnauf from './assets/images/certifikaty/knauf.png';
import certPozar from './assets/images/certifikaty/pozarneuzavery1.png';
import certPyroplex from './assets/images/certifikaty/pyroplex.png';
import certWeber from './assets/images/certifikaty/weber.png';
import certSolar from './assets/images/certifikaty/solar.png';
import certRigips from './assets/images/certifikaty/rigips.png';


export default function Certificates() {
  const [modalShow, setModalShow] = React.useState(false);
  const [certificateTitle, setCertTitle] = React.useState('');
  const [image, setImage] = React.useState();

  const styles = StyleSheet.create({
    about: {
      padding: "0em",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      '@media (max-width: 600px)': {
        flexDirection: 'column',
        justifyContent: 'flex-start',
      }
    },
    card: {
      margin: "2em 1em 2em 1em",
      '@media (max-width: 600px)': {
        margin: "0em",
        marginTop: "1em"
      }
    }
  });

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {certificateTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Image src={image} fluid rounded />
        </Modal.Body>
      </Modal>
      <div style={{ padding: "3em", display: "flex", flexDirection: "column", color: "rgba(15, 20, 36)", width: "100%" }}>
        <h3>Certifkáty</h3>
        <div className={css(styles.about)}>
          <Carousel responsive={responsive}>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("Montáž kontrukcí suché výstavby");
                setImage(certRigips);
              }}>
              <Card.Img variant="top" src={certRigips} />
              <Card.Body>
                <Card.Title>Montáž kontrukcí suché výstavby</Card.Title>
                <Card.Text>
                  Certifikát na montáž kontrokcí suché výstavby Rigips včetně konstrukcí protipožárních, bezpečnostních podhledů Rigips a OWA 
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("Systémy Baumit, spol. s.r.o.");
                setImage(certBaumit);
              }}>
              <Card.Img variant="top" src={certBaumit} />
              <Card.Body>
                <Card.Title>Systémy Baumit, spol. s.r.o.</Card.Title>
                <Card.Text>
                  Certifikát pro provádení systému Baumit.
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("Knauf Praha, spol. s.r.o.");
                setImage(certKnauf);
              }}>
              <Card.Img variant="top" src={certKnauf} />
              <Card.Body>
                <Card.Title>Knauf Praha, spol. s.r.o.</Card.Title>
                <Card.Text>
                  Montáž a kontrola protipožárných sadrokartonových systému.
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("CARMAN-DOORS, s.r.o.");
                setImage(certPozar);
              }}>
              <Card.Img variant="top" src={certPozar} />
              <Card.Body>
                <Card.Title>CARMAN-DOORS, s.r.o.</Card.Title>
                <Card.Text>
                  Montáž a kontrola požárných uzávěrů CARMAN-DOORS, s.r.o.
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("Pasívní požární ochrana Pyroplex");
                setImage(certPyroplex);
              }}>
              <Card.Img variant="top" src={certPyroplex} />
              <Card.Body>
                <Card.Title>Pasívní požární ochrana Pyroplex</Card.Title>
                <Card.Text>
                  Zpracování a využití systémů Pyroplex pro pasívní protipožárni ochranu.
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("WEBER Saint-Gabain CZ a.s.");
                setImage(certWeber);
              }}>
              <Card.Img variant="top" src={certWeber} />
              <Card.Body>
                <Card.Title>WEBER Saint-Gabain CZ a.s.</Card.Title>
                <Card.Text>
                  Praktické a teoretická aplikace materiálů Saint-Gabain.
            </Card.Text>
              </Card.Body>
            </Card>
            <Card style={{ margin: '1em' }}
              onClick={() => {
                setModalShow(true);
                setCertTitle("Instalace solárních termických soustav");
                setImage(certSolar);
              }}>
              <Card.Img variant="top" src={certSolar} />
              <Card.Body>
                <Card.Title>Instalace solárních termických soustav</Card.Title>
                <Card.Text>
                  Kvalifikace k provádení kvalifikované instalace solárních systémů.
            </Card.Text>
              </Card.Body>
            </Card>
          </Carousel>
        </div>
      </div>
    </>
  );
}
